<!--
  Aspedia VueJS Menu Component
  *=====
  Import Name:  nav-menu
  Name:         NavMenu
  Version:      1
  Date:         2018-03-13
  Author:       Christian Dale <cdale@aspedia.net>

  Description:      Generic navigation menu with dropdown support for i.e. Top Menu.
  Default Data:     N/A
  Component IMG:    N/A
  Ancestor:         N/A
  Available To:     N/A
  Builder Visible:  False
  Version History:
    1    2018-03-13    Christian Dale <cdale@aspedia.net>   Initial revision of the Tree Component.
  *=====
-->

<template>
  <b-nav-item
    v-if="depth === 0 && !hasChildren"
    :href="href"
    :to="href"
  >{{ title }}</b-nav-item>
  <b-dropdown-item
    v-else-if="!hasChildren"
    :href="href"
    :to="href"
  >{{ title }}</b-dropdown-item>
</template>

<script>
export default {
  name: 'nav-menu-item',
  props: {
    item: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      required: true
    },
    titleProp: {
      type: String,
      required: false,
      default: 'title'
    },
    hrefProp: {
      type: String,
      required: false,
      default: 'href'
    }
  },
  computed: {
    title: function() {
      return this.item[this.titleProp] ? this.item[this.titleProp] : ''
    },
    href: function() {
      return this.item[this.hrefProp] ? this.item[this.hrefProp] : ''
    },
    hasChildren: function() {
      return this.item.children && this.item.children.length > 0
    }
  }
}
</script>
